import React, { useEffect } from 'react';
import { Chip } from '@mui/material';
import { useState } from 'react';
import { useNotify, Confirm, useDelete } from 'react-admin';
import { refreshCeilsAGrid } from '../../../utils/common';
import { IAssignmentRecord, IAssignmentUser } from '../types';

/** Props for {@link Assign}. */
export interface IAssignProps {
    /** The AG Grid row's underlying `OrderAssignments` record. */
    data: IAssignmentRecord;
    /** AG Grid row API, used to stop editing and refresh cells after a delete. */
    api: any;
    /** List of assignable processors (unused directly, forwarded by the column def). */
    listUser?: IAssignmentUser[];
}

/**
 * AG Grid cell renderer for the `assignedTo` column: shows the assigned
 * user as a deletable `Chip`, backed by a confirm dialog that removes the
 * `OrderAssignments` record via `useDelete`.
 * @param props - AG Grid cell renderer props (`data`, `api`, ...).
 */
const Assign: React.FC<IAssignProps> = (props) => {
    const [open, setOpen] = useState<boolean>(false);//react-admin confirm
    const [assignedTo, setAssignedTo] = useState<any>();
    const [handleDelete] = useDelete();
    const notify = useNotify();

    useEffect(() => {
        if (props.data?.assignedTo)
            setAssignedTo(props.data.assignedTo);
    }, [props]);

    const hanldeDelete = (_: React.SyntheticEvent) => {
        props.api.stopEditing();
        setOpen(true);
    };

    const handleConfirm = () => {
        let order = props.data;
        handleDelete('OrderAssignments', { id: order.id }, {
            onSuccess: (_) => {
                notify('Delete successfully', { type: 'success', autoHideDuration: 2000 });
                props.api.stopEditing();
                props.data['assignedDate'] = null;
                props.data['assignedTo'] = null;
                refreshCeilsAGrid(props, ['assignedDate', 'assignedTo']);
                setAssignedTo(null);
            },
            onError: (error: any) => {
                notify(`Delete error: ${error.message}`, { type: 'error', autoHideDuration: 5000 });
                props.api.stopEditing();
            },
        });
        setOpen(false);
    };

    return (
        assignedTo ? (
            <React.Fragment>
                <Chip
                    size="small"
                    onDelete={hanldeDelete}
                    key={assignedTo} label={assignedTo} />
                <Confirm isOpen={open} title='Remove Order Assignment' content='Are you sure want to remove this order assignment?' onConfirm={handleConfirm} onClose={() => setOpen(false)} />
            </React.Fragment>
        ) : null
    );
};

export default Assign;
